import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MedicalSummaryFormComponent } from './components/medical-summary-form/medical-summary-form.component';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { InvoicesComponent } from './components/invoices/invoices.component';

@NgModule({
  declarations: [
    AppComponent,
    MedicalSummaryFormComponent,
    InvoicesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
